import createRoute          from '@widesk-ui/tools/createRoute';
import ProjectTemplateModel from '@models/map/ProjectTemplateModel';

export default createRoute.dashboard('/project_templates', 'map', 'ProjectTemplateDashboard', ProjectTemplateModel.localize());